import React from "react";
import MotivosBaseTemplate from "../shared/MotivosBaseTemplate";
import {
  alterarStatusMotivoVia,
  cadastrarMotivoVia,
  editarMotivoVia,
  excluirMotivoVia,
  listarMotivosVia,
} from "./motivosVia.api";

export default function MotivosViaBase() {
  return (
    <MotivosBaseTemplate
      titulo="Motivos VIA"
      descricao="Cadastre os motivos usados pelas interdições de VIA do CIM."
      placeholder="Ex.: ÁGUA SOBRE A VIA"
      hint="Use esta base para centralizar os motivos de VIA no CIM."
      listFn={listarMotivosVia}
      createFn={cadastrarMotivoVia}
      updateFn={editarMotivoVia}
      deleteFn={excluirMotivoVia}
      toggleFn={alterarStatusMotivoVia}
    />
  );
}
